<template>
  <v-menu
    :close-on-content-click="false"
    transition="slide-y-transition"
    top
    offset-y
    v-model="menu"
    :disabled="eventSelectorDisabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        fab
        color="primary"
        fixed
        right
        bottom
        class="d-flex d-md-none"
        :disabled="eventSelectorDisabled"
      >
        <v-icon dark>mdi-filter</v-icon>
      </v-btn>
    </template>
    <global-eventSelectorCard />
  </v-menu>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    menu: false,
  }),
  computed: {
    ...mapState("admin", ["eventSelectorDisabled"]),
  },
};
</script>

<style></style>
